export const dynamicPricing = {
  title: "Precificação Dinâmica",
  loading: "Carregando configurações…",
  status: {
    active: "Ativado",
    inactive: "Desativado",
  },
  close: "Fechar",
  unit: {
    label: "Acomodação",
    autoPill: "✦ Automático a partir do seu histórico",
  },
  tabs: {
    calendario: "Calendário",
    precio: "Preço base",
    reglas: "Regras",
    aplicacion: "Aplicação",
  },
  weekdaysShort: {
    mon: "Seg",
    tue: "Ter",
    wed: "Qua",
    thu: "Qui",
    fri: "Sex",
    sat: "Sáb",
    sun: "Dom",
  },
  cal: {
    stats: {
      adr: "ADR proj.",
      occupancy: "Ocupação",
      revenue: "Receita",
    },
    calculating: "Calculando preços…",
    minStayShort: "mín. {count}n | mín. {count}n",
  },
  legend: {
    low: "Baixo",
    base: "Base",
    high: "Alto",
    peak: "Pico",
    booked: "Reservado",
    override: "Fixo",
  },
  why: {
    title: "Por que {price} {curr} · {day}",
    chip: "explicação",
    nights: "{count} noite | {count} noites",
    minStay: "Estadia mínima: {nights} · piso {floor} / teto {ceil} {curr}",
    hint: "Toque em um dia para ver como o preço é calculado.",
  },
  apply: {
    diffPrefix: "Com os preços sugeridos:",
    diffSuffix: "em relação aos seus preços atuais de {month}.",
    apply: "Aplicar preços",
    applying: "Aplicando…",
    applyNow: "Aplicar agora",
    enableToApply: "Ative a Precificação Dinâmica para aplicar.",
    enableFirst: "Ative a Precificação Dinâmica primeiro.",
    autoNote: {
      prefix: "✓ No modo",
      mode: "Automático",
      mid: "os preços são aplicados",
      everyday: "todos os dias",
    },
    result: {
      hotelPending: "Hotéis (múltiplas unidades) ainda não são suportados nesta fase.",
      ok: "✓ Aplicado {count} dia ({from} → {to}) e enviado aos canais. | ✓ Aplicados {count} dias ({from} → {to}) e enviados aos canais.",
      failed: "Não foi possível aplicar os preços.",
    },
  },
  base: {
    title: "Preço base e limites",
    desc: "Sugerido a partir do seu histórico. O motor nunca sai desse intervalo.",
    basePerNight: "Base / noite",
    min: "Mínimo (piso)",
    max: "Máximo (teto)",
    rounding: "Arredondamento",
  },
  rounding: {
    integer: "Inteiro",
    ends0: "Termina em 0",
    ends9: "Termina em 9",
    multiple5: "Múlt. 5",
  },
  weekend: {
    title: "Fim de semana e estadia mínima",
    upliftLabel: "Acréscimo de fim de semana",
    daysLabel: "Dias de fim de semana:",
    minStayLabel: "Estadia mínima (noites)",
    minStayNormal: "Padrão",
    minStayWeekend: "Fins de semana / alta",
    orphanTitle: "Preencher noites órfãs",
    orphanDesc: "Estadias mais curtas ({pct}% de desconto) em intervalos de 1 a 2 noites.",
  },
  demand: {
    title: "Sensibilidade à demanda",
    desc: "Quanto a ocupação e o ritmo de reservas movem o preço.",
  },
  aggr: {
    low: "Conservador",
    medium: "Médio",
    high: "Agressivo",
  },
  seasons: {
    title: "Temporadas",
    namePlaceholder: "Nome",
    monthDayPlaceholder: "MM-DD",
    add: "+ Adicionar temporada",
  },
  events: {
    title: "Eventos (feiras, festivais…)",
    suggestWithAI: "✨ Sugerir com IA",
    suggesting: "Buscando…",
    namePlaceholder: "Nome",
    datePlaceholder: "YYYY-MM-DD",
    empty: "Nenhum evento. Adicione-os manualmente ou com IA.",
    add: "+ Adicionar evento",
    suggestionsHead: "Sugestões de IA{city} — revise as datas e adicione",
    addSuggestion: "+ Adicionar",
    noSuggestions: "Nenhuma sugestão (verifique se a acomodação tem uma cidade definida).",
  },
  demandRules: {
    title: "Regras de demanda",
    lastMinuteTitle: "Descontos de última hora",
    lastMinuteDesc: "Reduz o preço de datas próximas ainda em aberto.",
    holidaysTitle: "Feriados automáticos",
    holidaysDesc: "Aplica +{pct}% em feriados nacionais.",
    occupancyTitle: "Aumentar por ocupação",
    occupancyDesc: "Se o mês estiver mais de {threshold}% cheio, aumenta o preço.",
    weeklyDiscount: "Desc. semanal (7+) %",
    monthlyDiscount: "Desc. mensal (28+) %",
  },
  application: {
    title: "Modo e sincronização",
    modeLabel: "Modo de aplicação",
    modeSuggested: "Sugerido (eu reviso primeiro)",
    modeAuto: "Automático",
    syncTitle: "Sincronizar com os canais (Channex → Airbnb / Booking)",
    syncDesc: "Publica os preços calculados nos seus canais.",
    horizonLabel: "Horizonte de cálculo",
    horizonMonths: "{count} meses",
  },
  save: {
    saved: "Salvo ✓",
    saving: "Salvando…",
    save: "Salvar alterações",
  },
  errors: {
    forbidden: "Você não tem acesso a esta acomodação.",
    loadFailed: "Não foi possível carregar as configurações.",
    saveFailed: "Não foi possível salvar. Verifique os campos.",
  },
};
